/*
 * @Author: qiong
 * @LastEditTime: 2025-07-22 14:17:42
 */
import { createBundle } from 'widget/Common';

// import TimeLineView from 'bundle-loader?lazy&name=TimeLineView!pages/Shop/Home/TimeLineShare/TimeLineView';
import SpecialView from 'bundle-loader?lazy&name=SpecialView!pages/Shop/Home/Special/SpecialView';
import SpecialVideoPlayView from 'bundle-loader?lazy&name=SpecialVideoPlayView!pages/Shop/Home/Special/SpecialVideoPlay/SpecialVideoPlayView';
import OfficialInformationView from 'bundle-loader?lazy&name=OfficialInformationView!pages/Shop/Home/OfficialInformation/OfficialInformationView';
import SpecialProductView from 'bundle-loader?lazy&name=SpecialProductView!pages/Shop/Home/SpecialProduct/SpecialProductView';
import SpecialClassifyView from 'bundle-loader?lazy&name=SpecialClassifyView!pages/Shop/Home/SpecialClassify/SpecialClassifyView';
import LDOrderView from 'bundle-loader?lazy&name=SpecialView!pages/Shop/Home/LdOrder/LDOrderView';

import ThemeView from 'bundle-loader?lazy&name=ThemeView!pages/Shop/Home/Theme/ThemeView';
import ActivityView from 'bundle-loader?lazy&name=ActivityView!pages/Shop/Home/Activity/ActivityView';
import AggregateLinkView from 'bundle-loader?lazy&name=AggregateLinkView!pages/Shop/Home/AggregateLink/AggregateLinkView';
import NewsView from 'bundle-loader?lazy&name=NewsView!pages/Shop/Home/News/NewsView';
import NewsDetailView from 'bundle-loader?lazy&name=NewsDetailView!pages/Shop/Home/News/NewsDetail/NewsDetailView';
import ApplicationView from 'bundle-loader?lazy&name=ApplicationView!pages/Shop/Home/Application/ApplicationView';
import LandingPageView from 'bundle-loader?lazy&name=ApplicationView!pages/Shop/Home/LandingPage/LandingPageView';
import ProductClassfiyView from 'bundle-loader?lazy&name=ApplicationView!pages/Shop/Home/ProductClassfiy/ProductClassfiyView';
import SortActivityView from 'bundle-loader?lazy&name=SortActivityView!pages/Shop/Home/SortActivity/SortActivityView';
import SpecialSortActivityView from 'bundle-loader?lazy&name=SpecialSortActivityView!pages/Shop/Home/SpecialSortActivity/SpecialSortActivityView';

// 会员生日
import MemberBirthdayView from 'bundle-loader?lazy&name=MemberBirthdayView!pages/Shop/Home/MemberBirthday/MemberBirthdayView';
import BirthdayCardView from 'bundle-loader?lazy&name=BirthdayCardView!pages/Shop/Home/MemberBirthday/BirthdayCard/BirthdayCardView';
import BrotherBlessingView from 'bundle-loader?lazy&name=BrotherBlessingView!pages/Shop/Home/MemberBirthday/BrotherBlessing/BrotherBlessingView';
import FulaifuRoadView from 'bundle-loader?lazy&name=FulaifuRoadView!pages/Shop/Home/MemberBirthday/FulaifuRoad/FulaifuRoadView';
import GetBlessingView from 'bundle-loader?lazy&name=GetBlessingView!pages/Shop/Home/MemberBirthday/GetBlessing/GetBlessingView';
import ImportantSeriesView from 'bundle-loader?lazy&name=ImportantSeriesView!pages/Shop/Home/ImportantSeries/ImportantSeriesView';
//会员生日  选择视频
import SelectBirthdayVideo from 'bundle-loader?lazy&name=SelectBirthdayVideo!pages/Shop/Home/MemberBirthday/SelectBirthdayVideo';
// 视康月度手机排行榜
import SkRankingView from 'bundle-loader?lazy&name=SkRankingView!pages/Shop/Home/SkRanking/SkRankingView';
// 视康豪车排行榜
import SkCarRankingView from 'bundle-loader?lazy&name=SkCarRankingView!pages/Shop/Home/SkCarRanking/SkCarRankingView';
// 老鹰 光明行动排行榜
import LyBrightActionView from 'bundle-loader?lazy&name=LyBrightActionView!pages/Shop/Home/LyBrightAction/LyBrightActionView';
// 店主专享福利
import WeekYear2View from 'bundle-loader?lazy&name=WeekYear2View!pages/Shop/Home/Carnival/weekYear2/WeekYear2View';
// 芦荟胶定制活动页
import LhjActivityView from 'bundle-loader?lazy&name=ActivityView!pages/Shop/Home/Carnival/20230618/ActivityView';
// 震撼八月，限时拼团
import AugustActivityView from 'bundle-loader?lazy&name=ActivityView!pages/Shop/Home/Carnival/20230818/ActivityView';
// 三生公益活动
import PublicWelfareView from 'bundle-loader?lazy&name=PublicWelfareView!pages/Shop/Home/Carnival/commonweal/PublicWelfare/PublicWelfareView';
// 三生公益活动--我的捐款
import MyDonationView from 'bundle-loader?lazy&name=MyDonationView!pages/Shop/Home/Carnival/commonweal/MyDonation/MyDonationView';
// 三生公益协议
import ViewAgreementView from 'bundle-loader?lazy&name=ViewAgreementView!pages/Shop/Home/Carnival/commonweal/ViewAgreement/ViewAgreementView';
// 头等舱
import FirstClassView from 'bundle-loader?lazy&name=FirstClassView!pages/Shop/Home/FirstClass/FirstClassView';
// 专属服务
import ExclusiveServicesView from 'bundle-loader?lazy&name=ExclusiveServicesView!pages/Shop/Home/ExclusiveServices/ExclusiveServicesView';
// 生命健康 - 获取明细
import GetDetailsView from 'bundle-loader?lazy&name=GetDetailsView!pages/Shop/Home/GetDetails/index';

import HealthButler from 'bundle-loader?lazy&name=GetDetailsView!pages/Shop/Home/HealthButler/index';

import StoreInfoView from 'bundle-loader?lazy&name=StoreInfoView!pages/Shop/Home/StoreInfo/StoreInfoView';
// 云逛逛笔记
import YunNoteView from 'bundle-loader?lazy&name=YunNoteView!pages/Shop/Home/YunNote/YunNoteView';

const RouterConfig = [
  {
    path: '/shop/home/special/ldorder/:id',
    title: '乐道大单',
    component: () => {
      return createBundle(LDOrderView);
    }
  },
  // {
  //   path: '/shop/home/healthTimeLineShare',
  //   title: '专题活动',
  //   component: () => {
  //     return createBundle(TimeLineView);
  //   },
  // },
  {
    path: '/shop/home/specialVideoPlay',
    title: '视频播放',
    component: () => {
      return createBundle(SpecialVideoPlayView);
    }
  },
  {
    path: '/shop/home/special/:id',
    title: '专题活动',
    component: () => {
      return createBundle(SpecialView);
    }
  },
  {
    path: '/shop/home/officialInformation',
    title: '官方资讯',
    component: () => {
      return createBundle(OfficialInformationView);
    }
  },
  {
    path: '/shop/home/specialProduct/:id',
    title: '专题活动',
    component: () => {
      return createBundle(SpecialProductView);
    }
  },
  {
    path: '/shop/home/specialClassify/:id',
    title: '专题活动',
    component: () => {
      return createBundle(SpecialClassifyView);
    }
  },
  {
    path: '/shop/home/theme',
    title: '主题活动',
    component: () => {
      return createBundle(ThemeView);
    }
  },
  {
    path: '/shop/home/activity/:type/:id',
    title: '活动',
    component: () => {
      return createBundle(ActivityView);
    }
  },
  {
    path: '/shop/home/activity/AggregateLink/:id/:type',
    title: '聚合链接中转页',
    component: () => {
      return createBundle(AggregateLinkView);
    }
  },
  // ----- 资讯 -----
  {
    path: '/shop/home/news',
    title: '资讯',
    component: () => {
      return createBundle(NewsView);
    }
  },
  {
    path: '/shop/home/news/:id',
    title: '资讯详情',
    component: () => {
      return createBundle(NewsDetailView);
    }
  },
  // ----- 业务应用 -----
  {
    path: '/shop/home/application',
    title: '所有应用',
    component: () => {
      return createBundle(ApplicationView);
    }
  },
  // ----- 九月活动落地页 -----
  {
    path: '/shop/home/landingPage',
    title: '所有应用',
    component: () => {
      return createBundle(LandingPageView);
    }
  },
  // ----- 前端类目-一级分类 -----
  {
    path: '/shop/home/productClassfiy/:id',
    title: '所有应用',
    component: () => {
      return createBundle(ProductClassfiyView);
    }
  },
  {
    path: '/shop/home/sortActivityView',
    title: '排行榜活动',
    component: () => {
      return createBundle(SortActivityView);
    }
  },
  {
    path: '/shop/home/specialSortActivitityView',
    title: '定制排行榜活动',
    component: () => {
      return createBundle(SpecialSortActivityView);
    }
  },
  // ----- 前端类目-会员生日 -----
  {
    path: '/shop/home/memberBirthdayView',
    title: '编辑名片',
    component: () => {
      return createBundle(MemberBirthdayView);
    }
  },
  {
    path: '/shop/home/birthdayCardView',
    title: '生日卡',
    component: () => {
      return createBundle(BirthdayCardView);
    }
  },
  {
    path: '/shop/home/brotherBlessingView',
    title: '宝哥祝福',
    component: () => {
      return createBundle(BrotherBlessingView);
    }
  },
  {
    path: '/shop/home/fulaifuRoadView',
    title: '福来福往',
    component: () => {
      return createBundle(FulaifuRoadView);
    }
  },
  {
    path: '/shop/home/getBlessingView',
    title: '收祝福',
    component: () => {
      return createBundle(GetBlessingView);
    }
  },
  {
    path: '/shop/home/SelectBirthdayVideo',
    title: '选择视频',
    component: () => {
      return createBundle(SelectBirthdayVideo);
    }
  },
  {
    path: '/shop/home/importantSeriesView/:id',
    title: '重点系列',
    component: () => {
      return createBundle(ImportantSeriesView);
    }
  },
  {
    path: '/shop/home/skRankingView',
    title: '活动专题页',
    component: () => {
      return createBundle(SkRankingView);
    }
  },
  {
    path: '/shop/home/skCarRankingView',
    title: '活动专题页',
    component: () => {
      return createBundle(SkCarRankingView);
    }
  },
  {
    path: '/shop/home/lyBrightActionView',
    title: '活动专题页',
    component: () => {
      return createBundle(LyBrightActionView);
    }
  },
  {
    path: '/shop/home/weekYear2',
    title: '店主专享福利',
    component: () => {
      return createBundle(WeekYear2View);
    }
  },
  {
    path: '/shop/home/20230618',
    title: '店主专享福利',
    component: () => {
      return createBundle(LhjActivityView);
    }
  },
  {
    path: '/shop/home/20230818',
    title: '店主专享福利',
    component: () => {
      return createBundle(AugustActivityView);
    }
  },
  {
    path: '/shop/home/publicWelfareView',
    title: '三生公益活动',
    component: () => {
      return createBundle(PublicWelfareView);
    }
  },
  {
    path: '/shop/home/myDonationView',
    title: '三生公益',
    component: () => {
      return createBundle(MyDonationView);
    }
  },
  {
    path: '/shop/home/viewAgreementView',
    title: '三生公益协议',
    component: () => {
      return createBundle(ViewAgreementView);
    }
  },
  {
    path: '/shop/home/firstClass',
    title: '头等舱',
    component: () => {
      return createBundle(FirstClassView);
    }
  },
  {
    path: '/shop/home/exclusiveServices',
    title: '专属服务',
    component: () => {
      return createBundle(ExclusiveServicesView);
    }
  },
  {
    path: '/shop/home/getDetails',
    title: '获取明细',
    component: () => {
      return createBundle(GetDetailsView);
    }
  },
  {
    path: '/healthButler',
    title: '获取明细',
    component: () => {
      return createBundle(HealthButler);
    }
  },
  {
    path: '/storeInfo',
    title: '店铺详情',
    component: () => {
      return createBundle(StoreInfoView);
    }
  },
  {
    path: '/yunNote',
    title: '云逛逛笔记',
    component: () => {
      return createBundle(YunNoteView);
    }
  }
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/RouterConfig.js